import { render, staticRenderFns } from "./epidemic.vue?vue&type=template&id=f98be4a6"
import script from "./epidemic.vue?vue&type=script&lang=js"
export * from "./epidemic.vue?vue&type=script&lang=js"
import style0 from "./epidemic.vue?vue&type=style&index=0&id=f98be4a6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports